import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'appSrc/components/UI';
import { updateProductModal } from 'appSrc/redux/actions/productModalManager';
import style from './styles/style.module.css';


class AddProductCard extends PureComponent {
    openAddProductModal = () => {
        var detail = {
            showModal: 'lookupModal',
            type: 'new',
            showListOptions: false,
            product: {},
        };
        if( this.props.listid ) {
            detail.product.listid = this.props.listid;
        }
        this.props.dispatch( updateProductModal( detail ) );
    }
    render() {
        var inlineStyles = { ...this.props.style };
        if( this.props.width ) {
            inlineStyles.width = this.props.width;
            inlineStyles.height = this.props.width;
        }
        return (
            <div className={ `${ style.productCard } ${ style.addCard }` }
            onClick={ this.openAddProductModal }
            style={ inlineStyles }>
                <div className={ style.makeNewProductItem } >
                    <Icon icon='plus-colored' size={ 88 } />
                    <p>Add New Product</p>
                </div>
            </div>
        );
    }
}
AddProductCard.defaultProps = {
    style: {},
};


export default connect()( AddProductCard );
